import { Star } from "@phosphor-icons/react";

/** StarRating — read-only or interactive.
 *  Props: value (0-5), onChange? (interactive when provided), size, showLabel
 */
export default function StarRating({ value = 0, onChange, size = 14, showLabel = false, count }) {
  const isInteractive = typeof onChange === "function";
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="flex items-center gap-1">
      <div className="flex items-center">
        {stars.map((n) => {
          const filled = n <= Math.round(value);
          return (
            <button
              key={n}
              type="button"
              onClick={isInteractive ? () => onChange(n) : undefined}
              disabled={!isInteractive}
              className={isInteractive ? "cursor-pointer hover:scale-110" : "cursor-default"}
              style={{ transition: "transform 120ms ease-out" }}
              aria-label={`${n} star${n > 1 ? "s" : ""}`}
            >
              <Star size={size} weight={filled ? "fill" : "regular"} color={filled ? "#D49A36" : "#B8AC9A"} />
            </button>
          );
        })}
      </div>
      {showLabel && (
        <span className="text-xs font-semibold text-[#5C564D] ml-1">
          {value > 0 ? value.toFixed(1) : "—"}{count != null && ` (${count})`}
        </span>
      )}
    </div>
  );
}
